import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCC98nj_QNCnWjSP3AZT0iNFEi6c-05GU4",
  authDomain: "honki-tcg-tracker.firebaseapp.com",
  projectId: "honki-tcg-tracker",
  storageBucket: "honki-tcg-tracker.firebasestorage.app",
  messagingSenderId: "452705942266",
  appId: "1:452705942266:web:5ea81c26ee4fd1c1e16743"
};

const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
